import { Refresh, Close } from '@mui/icons-material';
import { IconButton, Snackbar, Typography } from '@mui/material';
import { UpdateStatus, useAppUpdateCheck } from 'hooks/UseAppUpdateCheck';
import React, { useState } from 'react';

const UpdateNotificationContainer = () => {
    const { version, status, reloadPage } = useAppUpdateCheck({
        ignoreServerCache: true,
        interval: 60000,
    });

    const [open, setOpen] = useState(true)

    if (status === UpdateStatus.checking || status === UpdateStatus.current) {
        return null;
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="medium"
                aria-label="refresh"
                onClick={reloadPage}
            >
                <Refresh fontSize="medium" sx={{ color: 'white' }} />
            </IconButton>
            <IconButton
                size="medium"
                aria-label="close"
                onClick={handleClose}
            >
                <Close fontSize="medium" sx={{ color: 'white' }} />
            </IconButton>
        </React.Fragment>
    )

    return (
        <Snackbar
            open={open}
            onClose={handleClose}
            message={<Typography color="white">New App update available <i><b>{version}</b></i></Typography>}
            action={action}
        />
    )
};

export { UpdateNotificationContainer }